/* eslint-disable */
import {
  Checkbox,
  Flex,
  Popover,
  Radio,
  Space,
  Button,
  Dropdown,
  Modal,
  message,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import {
  CaretDownOutlined,
  OneToOneOutlined,
  SyncOutlined,
  VerticalAlignBottomOutlined,
  MenuOutlined,
  EditOutlined,
  PlusOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import api from "@/utils/api";
import http from "@/utils/http";
import moment from "moment";
import { CustomTable } from "@/hocComponents";
import commonFn from "@/utils/commonFn";
import AddModal from "./component/addModal";
import ResetModal from "./component/editModal";
import "./component/index.scss";
export default function OwnerIndex() {
  const addModalRef = useRef(null);
  const EditModalRef = useRef(null);
  // 默认选中的值
  const [selectedItems, setSelectedItems] = useState([]);
  const [options, setOptions] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [exportLoading, setExportLoading] = useState(false);
  const [columns, setColumns] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  // 处理选项变化
  const handleChange = (checkedValues) => {
    setSelectedItems(checkedValues);
    setColumns(
      initColumns.map((item) => ({
        ...item,
        hidden: !checkedValues.includes(item.dataIndex),
      }))
    );
  };

  const showModal = () => {
    addModalRef.current?.setModelAdd();
  };
  // Popover 的内容
  const content = (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <Checkbox.Group
        options={options}
        value={selectedItems}
        className="checkBox"
        onChange={handleChange}
      >
        <Space direction="vertical">
          {options.map((option) => (
            <Checkbox key={option.value} value={option.value}>
              {option.label}
            </Checkbox>
          ))}
        </Space>
      </Checkbox.Group>
    </div>
  );

  const handleMenuClick = async (e, record) => {
    console.log(record, "record");
    if (e.key === "edit") {
      EditModalRef.current?.open(record);
    }

    if (e.key === "upload") {
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (keys) => setSelectedRowKeys(keys),
  };
  const handleExport = async () => {
    if (exportLoading) return; // 防止重复点击

    setExportLoading(true);

    try {
      const params = {
        page: pagination.current,
        count: pagination.pageSize,
        ...tableHead,
      };

      // 如果选中了行 → 只导出选中的 bankId
      if (selectedRowKeys.length > 0) {
        params.ownerIds = selectedRowKeys.join(",");
      }

      const response = await http.get(api.getOwnerExcel, {
        params,
        responseType: "blob",
      });

      const blob = new Blob([response], { type: "application/vnd.ms-excel" });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `Owner_List_${moment().format("MM/DD/YYYY")}.xlsx`;
      a.click();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      message.error("Failed to export file");
    } finally {
      setExportLoading(false);
    }
  };
  const content2 = (
    <div
      onClick={!exportLoading ? handleExport : undefined}
      style={{ cursor: exportLoading ? "not-allowed" : "pointer" }}
    >
      {exportLoading ? "Exporting..." : "Export to CSV"}
    </div>
  );
  // table
  const initTableHead = {
    role: null,
    module: null,
    firstName: null,
    dateTimeRequest: null,
  };
  const [tableHead, setTableHead] = useState(initTableHead);

const tableFilterFn = (event, key, type = "Input") => {
  commonFn.tableFilterFn({ 
    event, 
    key, 
    type, 
    setTableHead, 
    getTableListFn,
    pageSize: pagination.pageSize
  });
};
  const initColumns = [
  
    {
      title: "Action",
      key: "action",
      dataIndex: "bankId",
      hidden: false,
      align: "center",
      width: 60,
      //      render: (text, record) => (
      //       (
      //         commonFn.btnAuthorityFlag('Edit Bank Information') ||
      //         commonFn.btnAuthorityFlag('Upload Signature')
      //       ) && (
      //      <Dropdown
      //   menu={{
      //     items: [
      //       {
      //         key: "edit",
      //         icon: <EditOutlined style={{ color: "#00c0ef", fontSize: 17 }} />,
      //         label: <div>Edit Bank Information</div>,
      //       },
      //     ],
      //     onClick: (e) => handleMenuClick(e, record),
      //   }}
      //   trigger={["click"]}
      // >
      //   <MenuOutlined
      //     style={{ cursor: "pointer", fontSize: 16, color: "#0e78a9" }}
      //   />
      // </Dropdown>
      //         )
      //     ),
      render: (text, record) => (
        <Dropdown
          menu={{
            items: [
              {
                key: "edit",
                icon: (
                  <EditOutlined style={{ color: "#00c0ef", fontSize: 17 }} />
                ),
                label: <div>Edit Owner Information</div>,
              },
            ],
            onClick: (e) => handleMenuClick(e, record),
          }}
          trigger={["click"]}
        >
          <MenuOutlined
            style={{ cursor: "pointer", fontSize: 16, color: "#0e78a9" }}
          />
        </Dropdown>
      ),
    },

    {
      title: "Owner Code",
      dataIndex: "ownerCode",
      titleType: "Input",
      isSorter: true,
      width:100,
      onChange: (e) => tableFilterFn(e, "ownerCode"),
    },
    // {
    //   title: "First Name",
    //   dataIndex: "firstName",
    //   titleType: "Input",
    //   width:130,
    //   onChange: (e) => tableFilterFn(e, "firstName"),
    // },
    // {
    //   title: "Middle Name",
    //   dataIndex: "middleName",
    //   titleType: "Input",
    //  width:120,
    //   onChange: (e) => tableFilterFn(e, "middleName"),
    // },

    // {
    //   title: "Last Name",
    //   dataIndex: "lastName",
    //   titleType: "Input",
    //   width:130,
    //   onChange: (e) => tableFilterFn(e, "lastName"),
    // },
        {
      title: "Name",
      dataIndex: "name",
      titleType: "Input",
      isSorter: true,
      width:180,
      onChange: (e) => tableFilterFn(e, "name"),
    },
   {
      title: "Active Entities",
      dataIndex: "activeEntityCount",
        // titleType: "Input",
      isSorter: true,
      width:80,
      onChange: (e) => tableFilterFn(e, "activeEntityCount"),
     
    },
     {
      title: "Address",
      dataIndex: "address",
      titleType: "Input",
      width:240,
      onChange: (e) => tableFilterFn(e, "address"),
    },
    // {
    //   title: "Address",
    //   dataIndex: "street",
    //   titleType: "Input",
    //   width:240,
    //   onChange: (e) => tableFilterFn(e, "street"),
    // },
    // {
    //   title: "City",
    //   dataIndex: "city",
    //   titleType: "Input",
    //   width: 120,
    //   onChange: (e) => tableFilterFn(e, "city"),
    // },
    // {
    //   title: "State",
    //   dataIndex: "state",
    //   titleType: "Input",
    //   width: 100,
    //   onChange: (e) => tableFilterFn(e, "state"),
    // },

    // {
    //   title: "Zip",
    //   dataIndex: "zip",
    //   titleType: "Input",
    //   width:100,
    //   onChange: (e) => tableFilterFn(e, "zip"),
    // },
    {
      title: "Phone",
      dataIndex: "phone",
      titleType: "Input",
      isSorter: true,
      width:100,
      onChange: (e) => tableFilterFn(e, "phone"),
    },
    {
      title: "Email",
      dataIndex: "email",
      titleType: "Input",
      isSorter: true,
      width:180,
      onChange: (e) => tableFilterFn(e, "email"),
    },
     {
      title: "Owner Status",
      dataIndex: "ownerStatus",
      titleType: "Input",
      isSorter: true,
      width:180,
      onChange: (e) => tableFilterFn(e, "ownerStatus"),
    },
  ];

  // 获取列表数据
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      ...tableHead,
    orderField: tableHead?.orderField || "",
    orderType: tableHead?.orderType || "",
    };
    const response = await http.get(api.getOwnerTableList, { params });
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response);
      setTableLoading(false);
      return;
    }
    const list = (response.data.list || []).map((item, index) => ({
      ...item,
      "#": (params.page - 1) * params.count + index + 1,
      key: item.ownerId,
    }));
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };

const handleTableChange = (pagination, filters, sorter) => {
  const tableHeadTemp = {
    ...tableHead,
    orderField: sorter.field || "",
    orderType: sorter.order === 'ascend' ? 'asc' : sorter.order === 'descend' ? 'desc' : "",
  };
  setTableHead(tableHeadTemp);
  getTableListFn(pagination.current, pagination.pageSize, tableHeadTemp);
};

  const initColunmsFn = () => {
    setTableHead(initTableHead);
    setColumns(initColumns);
    const transformedList = initColumns.map((item) => ({
      label: item.title,
      value: item.dataIndex,
    }));
    setOptions(transformedList);
    const transformedList2 = initColumns.map((item) => item.dataIndex);
    setSelectedItems(transformedList2);
  };

  const handleDelete = async () => {
    if (selectedRowKeys.length === 0) {
      return message.warning("Please select at least one record.");
    }

    Modal.confirm({
      title: "Confirm Delete",
      content: `Are you sure you want to delete ${selectedRowKeys.length} items?`,
      okText: "Delete",
      okType: "danger",
      cancelText: "Cancel",

      onOk: async () => {
        try {
          const ids = selectedRowKeys.join(",");
          const res = await http.get(api.getOwnerDelete, {
            params: { ownerId: ids },
          });

          if (res.code === "1") {
            message.success("Delete Successfully");
            setSelectedRowKeys([]);

            setRefreshKey(Date.now());
          } else {
            message.error(res.msg || "Delete Failed");
          }
        } catch (err) {
          message.error("Request Error");
        } finally {
          // setTableLoading(false);
        }
      },
    });
  };

  useEffect(() => {
    initColunmsFn();
    getTableListFn(1, 25);
  }, [refreshKey]);

  return (
    <div>
      <Flex className="topDiv" justify="space-between" align="flex-start">
        <div>
          <Button className="btnNew" onClick={showModal}>
            <PlusOutlined />
            New
          </Button>
          <Button className="btnDEL" onClick={handleDelete}>
            <DeleteOutlined />
            Delete
          </Button>
        </div>
        <div className="min-width">
          <Radio.Group defaultValue="a" size="middle">
            <Radio.Button value="a" onClick={() => setRefreshKey(+new Date())}>
              <SyncOutlined />
            </Radio.Button>
            <Radio.Button value="b">
              <Popover content={content} title="" trigger="click">
                <OneToOneOutlined />
                <CaretDownOutlined className="ft12" />
              </Popover>
            </Radio.Button>
            {/* {commonFn.btnAuthorityFlag('Download') && <Radio.Button value="c">
              <Popover content={content2} title="" trigger="click">
                <VerticalAlignBottomOutlined />
                <CaretDownOutlined className="ft12" />
              </Popover>
            </Radio.Button>} */}
            <Radio.Button value="c">
              <Popover content={content2} title="" trigger="click">
                <VerticalAlignBottomOutlined />
                <CaretDownOutlined className="ft12" />
              </Popover>
            </Radio.Button>
          </Radio.Group>
        </div>
      </Flex>
      <CustomTable
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableCss="maintenanceTable"
        rowKey="ownerId"
        rowSelection={rowSelection}
      />
      <AddModal
        ref={addModalRef}
        onSuccess={() => {
          getTableListFn(pagination.current, pagination.pageSize, tableHead);
        }}
      />

      {/* ResetModal */}
      <ResetModal
        ref={EditModalRef}
        onSuccess={() => {
          getTableListFn(pagination.current, pagination.pageSize, tableHead);
        }}
      />
    </div>
  );
}
